<template>
	<v-app :style="allSettingsVariables">
    <notifyWrapper/>
    <!-- CONTENT -->
    <v-main  :style="`background: ${this.$route.name.toLowerCase() == 'homepageanon' ? this.$vuetify.theme.themes.light.accent : 'white'} `">
      <v-progress-linear
      v-if="loader"
      indeterminate
      height="5"
      color="primary"
      absolute
    ></v-progress-linear>
      <dr-layout-placeholder v-if="this.$route.name.toLowerCase() == 'homepageanon'" style="height: 100%;" :model="{$ID:'pl3'+this.routeName, Name:'Main'}">
      </dr-layout-placeholder>
      <div class="content-container" v-else>
        <dr-layout-main-component :items="layoutDescription" :withoutBorderMode="true"></dr-layout-main-component>
      </div>
    </v-main>
    <div style="display:none">
      <lang-switcher ref="langSwitcher"/>
    </div>
  </v-app>
</template>
<script>


import mainMenuMixin from '@/mainMenuSrc/mixins/mainMenuMixin'
import contextMenuMixin from '@/mainMenuSrc/mixins/contextMenuMixin'

import '@/mainMenuSrc/styles/mainMenu.css'
import NotifyWrapper from '@/components/NotifyWrapper'
import UserSettings from '@/mainMenuSrc/api/userSettings'
import LangSwitcher from '@/components/LangSwitcher'

export default {
  name: 'LayoutWithoutToolbar',
  mixins: [mainMenuMixin, contextMenuMixin],
  components: {
    NotifyWrapper,
    'dr-layout-main-component': () => import('../components/customWidgets/dr-layout-main-component.vue'),
    LangSwitcher
  },
  computed: {
    allSettingsVariables() {
      return UserSettings.GetAllSettingsVariable(this.userSettings)
    }
  },
  mounted() {
    if (window.self !== window.top) {
      let query = location.search.indexOf('?') >= 0 ? location.search.substring(location.search.indexOf('?') + 1) : location.search
      let parts = query.split('&')
      if (parts.length == 0 || (parts.length == 1 && !parts[0])) {
        return
      }
      let langParam = parts.find(e => e.includes('lang'))
      if (langParam && this.$refs.langSwitcher) {
        let lang = langParam.substr(langParam.indexOf('=') + 1).toLowerCase()
        if (this.$refs.langSwitcher.lang.code != lang) {
          this.$refs.langSwitcher.lang = lang
        }
      }
    }
  }
}
</script>

<style>
.content-container {
  background: #f2f3f4;
}
</style>
